module.exports = __webpack_public_path__ + "static/media/icon_checkout_cart.f789f32f.svg";